import { PermissionTypeDto } from './permission-type-dto';

export class DirectoryDto {
    id = -1;
    name = '';
    ownerPrincipalId = -1;
    childDirectories: DirectoryDto[] = [];
    permissions?: PermissionTypeDto;
}
